import * as R from 'ramda';

export default function uniqueVendorNameDirective(
  $q,
  vmSharedModelService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, el, attrs, ctrl) {
    const vendorId = attrs.vendorId || -1;

    ctrl.$asyncValidators.uniqueVendorName = (modelValue) => {
      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty model valid. This is probably the view's initial load.
        return $q.resolve();
      }

      const name = _getName(modelValue);

      if (!name) {
        // Nothing to check, move along... move along...
        return $q.resolve();
      }

      const def = $q.defer();

      // We have a name, so see if it exists
      vmSharedModelService.checkVendorNameExists(vendorId, name).then((isExists) => {
        if (!isExists) {
          def.resolve();
        } else {
          def.reject();
        }
      }).catch(() => def.reject());

      return def.promise;
    };
  }

  function _getName(modelValue) {
    switch (R.type(modelValue)) {
      case 'Object':
        return modelValue.name;
      default:
        // Assume modelValue is a string
        return modelValue;
    }
  }
}

export const name = 'uniqueVendorName';

uniqueVendorNameDirective.$inject = [
  '$q',
  'vmSharedModelService'
];
